import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const Insurance = () => {
  document.title = "Insurance";
  const [isLoading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();


  const permissions = localStorage.getItem("permissionStored");
  const parsedPermissions = JSON.parse(permissions);
  console.log("add_insurance permission:", parsedPermissions.add_insurance);
  const addPermission = parsedPermissions.add_insurance;

  const token = localStorage.getItem("Thyra_Token");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.03,
    },
    {
      field: "name",
      headerName: "Full Name",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      renderCell: (cellValues) => (
        <Button
        sx={{
          color: "#000000",
          textTransform: "none",
          justifyContent: "flex-start",
          fontWeight: "bold",
          fontSize: "0.95rem",
          "&:hover": {
            color: "#195C5F",
            textDecoration: "underline",
            transition: "color 0.2s ease-in-out",
          },
        }}
          onClick={() => {
            openInsuranceForm(cellValues.row.id); // Fixed to use openInsuranceForm
          }}
        >
          {`${cellValues.row.name}`}
        </Button>
      ),
    },
    {
      field: "email",
      headerName: " Email",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "phone",
      headerName: " Phone",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },

    {
      field: "state",
      headerName: " State",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "zip",
      headerName: " Zip",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "address",
      headerName: " Address",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "city",
      headerName: " City",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 0.1,
      sortable: false,
      renderCell: ({ row }) => (
        <IconButton
          sx={{
            color: "#D32F2F",
            "&:hover": { bgcolor: "#EAF1F5", transition: "background 0.2s" },
          }}
          onClick={() => {
            confirmAlert({
              message: "Do you want to delete this insurance record?",
              buttons: [
                {
                  label: "Yes",
                  onClick: () => {
                    axios
                      .post(
                        `${process.env.REACT_APP_API_URL}/Insurances/AddInsurances`,
                        {
                          id: row.id,
                          inactive: true,
                        },
                        { headers }
                      )
                      .then(() => setRefresh(!refresh))
                      .catch((error) => console.error("Delete Error:", error));
                  },
                },
                { label: "No" },
              ],
            });
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Insurances/getInsurance`, {
        headers,
      })
      .then((response) => {
        setRows(response || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching insurances:", error);
        setRows([]);
        setLoading(false);
      });
  }, [refresh]);

  const openInsuranceForm = (id = 0) => {
    navigate("/InsuranceRegistration", { state: { insuranceId: id } });
  };

  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: "lg" }}>
      {/* <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#2B7B7E" }}>
          Insurance
        </Typography>
      </Box> */}
      <Box sx={{ mb: 3, display: "flex", justifyContent: "flex-end" }}>

        { 
          addPermission? (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => openInsuranceForm()}
          sx={{
            bgcolor: "#2B7B7E",
            color: "#FFFFFF",
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 500,
            px: 3,
            py: 1,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              bgcolor: "#77A2A7",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
              transition: "all 0.3s",
            },
          }}
        >
          Add Insurance
        </Button>
              
            ): (null)
          }
      </Box>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress sx={{ color: "#2B7B7E" }} />
        </Box>
      ) : rows.length === 0 ? (
        <Box sx={{ py: 8, textAlign: "center" }}>
          <Typography
            sx={{ color: "#77A2A7", fontSize: "1.2rem", fontWeight: 500 }}
          >
            No insurance records found
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
            overflow: "hidden",
          }}
        >
          <DataGrid
            autoHeight
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                bgcolor: "#F5F7F9",
                color: "#2B7B7E",
                fontWeight: "bold",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #E0E0E0",
              },
              "& .MuiDataGrid-footerContainer": {
                bgcolor: "#F5F7F9",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: "#ffffff",
              },
            }}
          />
        </Box>
      )}
    </Container>
  );
};

export default Insurance;
